function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import classnames from 'classnames';
import { sanitizeContent } from "../../Utility/Utility";
import { Link } from "../../Button/Link/Link";
import { Text } from "../../Text/Text/Text";
import { Image } from "../../Image/Image/Image";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Background } from "../../Background/Background";
import { IconItemList } from "../../List/IconItemList/IconItemList";
import { Container } from "../../Container/Container/Container";
import { MatchHeight } from "../../Utility/MatchHeight/MatchHeight";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import styles from "./ColumnIconListSlice.module.scss";
import { VerticalSpacer } from "../../VerticalSpacer/VerticalSpacer";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var columnIconListIconSize = ['small', 'medium', 'large'];
export var ColumnIconListSlice = function ColumnIconListSlice(_ref) {
  var _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    background = _ref.background,
    headline = _ref.headline,
    iconItems = _ref.iconItems,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 'large' : _ref$iconSize,
    marginVariant = _ref.marginVariant,
    _ref$mobileScroll = _ref.mobileScroll,
    mobileScroll = _ref$mobileScroll === void 0 ? false : _ref$mobileScroll,
    _ref$subheading = _ref.subheading,
    subheading = _ref$subheading === void 0 ? '' : _ref$subheading,
    verticalSpacer = _ref.verticalSpacer,
    verticalSpacerInner = _ref.verticalSpacerInner,
    _ref$processJSON = _ref.processJSON,
    processJSON = _ref$processJSON === void 0 ? false : _ref$processJSON;
  var ids = [];
  var headingTextAdjustment = headline !== null && headline !== void 0 && headline.text && processJSON ? sanitizeContent(headline === null || headline === void 0 ? void 0 : headline.text) : headline === null || headline === void 0 ? void 0 : headline.text;
  var subheadingTextAdjustment = subheading && processJSON ? sanitizeContent(subheading) : subheading;
  var renderMobileScrollLinks = function renderMobileScrollLinks() {
    var theme = background.theme;
    var links = iconItems === null || iconItems === void 0 ? void 0 : iconItems.map(function (item, idx) {
      var icon = item.icon,
        headline = item.headline,
        mobileScrollIcon = item.mobileScrollIcon;
      var scrollId = "icon-item-".concat(index, "-").concat(idx);
      ids.push(scrollId);
      return icon && /*#__PURE__*/_jsx("li", {
        className: styles.scrollLinkItem,
        children: /*#__PURE__*/_jsxs(Link, {
          stopPropagation: true,
          url: "#".concat(scrollId),
          children: [/*#__PURE__*/_jsx("div", {
            className: classnames({
              [styles.scrollLinkIconWrapper]: true,
              [styles.scrollLinkIconWrapperDarkBackground]: theme === 'darkBackground'
            }),
            children: /*#__PURE__*/_jsx("div", {
              className: styles.scrollLinkIcon,
              children: /*#__PURE__*/_jsx(Image, {
                alt: icon.alt,
                src: mobileScrollIcon || icon.image1x || '',
                width: "40",
                height: "40"
              })
            })
          }), /*#__PURE__*/_jsx(Text, {
            className: styles.scrollLinkHeadline,
            typog: "bodycopySmall",
            richText: true,
            children: headline
          })]
        })
      }, idx);
    });
    return /*#__PURE__*/_jsx("ul", {
      className: styles.scrollWrapper,
      children: links
    });
  };
  return /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, background), {}, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(VerticalSpacer, _objectSpread(_objectSpread({}, verticalSpacer), {}, {
        className: styles.wrapper,
        "data-e2e-name": "column_icon_list_slice",
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.content,
          children: [headingTextAdjustment && /*#__PURE__*/_jsx(HeadingText, {
            richText: true,
            align: headline.align,
            ariaLevel: headline.ariaLevel || 2,
            className: classnames({
              [styles.headline]: true,
              [styles.finalHeading]: !subheading
            }),
            typog: headline.typog,
            children: headingTextAdjustment
          }), subheadingTextAdjustment && /*#__PURE__*/_jsx("div", {
            className: classnames(styles.subheading, styles.finalHeading),
            children: /*#__PURE__*/_jsx(HeadingText, {
              richText: true,
              align: headline.align,
              className: styles.headline,
              typog: "bodycopyLarge",
              textElement: "p",
              children: subheadingTextAdjustment
            })
          }), /*#__PURE__*/_jsxs(Breakpoint, {
            breakpoint: "mobile",
            children: [/*#__PURE__*/_jsx("div", {}), mobileScroll && renderMobileScrollLinks()]
          }), /*#__PURE__*/_jsx(MatchHeight, {
            bypass: "responsive",
            breakpoint: "small",
            children: function children(breakpoint) {
              return /*#__PURE__*/_jsx(IconItemList, {
                ids: breakpoint === 'below' ? ids : [],
                align: align,
                iconSize: iconSize,
                iconItems: iconItems,
                fileIconClass: styles.icon,
                verticalSpacer: verticalSpacerInner,
                marginVariant: marginVariant,
                processJSON: processJSON
              });
            }
          })]
        })
      }))
    })
  }));
};